export interface PreferenceOnUpdateParams {
  key: string;
  value: boolean;
}

export enum ResponseCodes {
  SUCCESS = 0,
  INVALID_REQUEST_PARAMETER = -1,
  INTERNAL_SERVER_ERROR = 500,
}
